<template>
  <div class="preview-wrapper"
    v-loading.fullscreen="isRequesting"
    element-loading-text="サーバーに問い合わせています">

    <template v-if="isInitialized">
      <div :class="['preview', previewSize]">
        <div class="post">

          <template v-for="type in ['navigation', 'sidebar']">
            <template v-if="themes[type] && themes[type].id">
              <div :is="getComponentNameById(themes[type].id)"
                :component="themes[type]"
                :preview-size="previewSize" :lock="true"></div>
            </template>
          </template>

          <header class="single-header flex column-reverse justify-center">
              <h2 class="single-heading">{{ post.title.rendered }}</h2>
              <div class="single-meta">
                  <p class="single-date"><time class="single-time">{{ formatDate(post.date) }}</time>公開</p>
                  <p class="single-date"><time class="single-time">{{ formatDate(post.modified) }}</time>更新</p>
              </div>
          </header>

          <el-form class="form">
            <!-- <template v-if="post.header">
              <div :is="getComponentNameById(header.component.id)"
                :component="header.component"
                :preview-size="previewSize"
                v-on:update="updateComponent('header', $event)"
                v-on:delete="deleteComponent('header')"></div>
            </template> -->

            <template v-for="(component, index) in post.components">
              <div class="component-wrapper">

                <div :is="getComponentNameById(component.id)"
                  :index="index" :positionMax="post.components.length"
                  :component="component"
                  :preview-size="previewSize"
                  v-on:update="updateComponent(index, $event)"
                  v-on:delete="deleteComponent(index)"></div>

                <template v-if="post.components.length - 1 > index">
                  <div class="component-swap flex justify-center items-center"  @click="swapComponents(index)"><el-tooltip class="item" effect="dark" content="Swap component" placement="top-start">
                      <i class="fa fa-arrows-v" aria-hidden="true"></i>
                    </el-tooltip>
                  </div>
                </template>
              </div>
            </template>
          </el-form>

          <template v-if="post.components.length === 0">
            <div class="component-warning flex justify-center items-center" @click="dialogComponentsVisible = true">
              <span class="component-warning-span">ここをクリックしてコンポーネントを追加してコンテンツを編集してください</span>
            </div>
          </template>

          <template v-for="type in ['footer']">
            <template v-if="themes[type]">
              <div :is="getComponentNameById(themes[type].id)"
                :component="themes[type]"
                :preview-size="previewSize" :lock="true"></div>
            </template>
          </template>

        </div>
      </div>
    </template>

    <el-dialog class="select-components-dialog flex flex-column" width="75%" title="コンテンツ用のコンポーネントを追加してください" :visible.sync="dialogComponentsVisible">
      <select-component @select="selectComponent($event)"></select-component>
    </el-dialog>

    <fab
      position="bottom-left"
      bg-color="#20a0ff"
      icon-size="small"
      main-icon="settings"
      :actions="fabActions"
      @native="previewSize = 'native'"
      @smartphone="previewSize = 'smartphone'"
      @tablet="previewSize = 'tablet'"
      @desktop="previewSize = 'desktop'"
      @launch="window.open(post.link, '_blank')"
      @add="addComponent"
      @sync="onSubmit($event)"></fab>

    <el-dialog width="50%" :title="error.title" :visible.sync="dialogErrorVisible">
      <span>{{ error.message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogErrorVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import union from 'lodash/union'
import RouteBase from '@/components/mixins/RouteBase'
import SelectComponent from '@/components/app/SelectComponent'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import FAB from 'vue-fab'
import AppAPI from '@/api'

export default {
  name: 'Post',
  mixins: [RouteBase],
  components: {
    fab: FAB,
    'select-component': SelectComponent
  },
  props: ['id'],
  data () {
    return {
      window: window,
      appTemplates: AppAPI.templatesArray.filter(template => template.meta.type === 'driving').map(template => {
        /**
         * componentsは
         *   "components": [4003, 4004, 4002]
         * のようにIDを含む配列か
         *   "components": [{"id": 4003, ...}]
         * のようにカスタムcontentsが設定されたオブジェクトのどちらかになっている
         * 前者の場合はコンポーネントのデフォルトのcontentsを使用する
         */
        const components = template.components.map(component => {
          if (typeof component === 'number') {
            return {...AppAPI.components[component]}
          } else {
            let matched = {...AppAPI.components[component.id]}
            matched.contents = {...component.contents}
            return matched
          }
        })
        return {id: template.id, meta: template.meta, components}
      }),
      previewSize: 'native',
      dialogComponentsVisible: false,
      dialogTemplatesVisible: false
    }
  },
  computed: {
    fabActions: function () {
      return [
        {name: 'native', icon: 'devices', tooltip: 'ディスプレイサイズでプレビュー'},
        {name: 'smartphone', icon: 'smartphone', tooltip: 'スマホサイズでプレビュー'},
        {name: 'tablet', icon: 'tablet', tooltip: 'タブレットサイズでプレビュー'},
        {name: 'desktop', icon: 'desktop_mac', tooltip: 'デスクトップサイズでプレビュー'},
        {name: 'add', icon: 'add', tooltip: 'コンポーネント追加'},
        {name: 'sync', icon: 'sync', tooltip: '変更を保存'}
      ]
    }
  },
  methods: {
    /**
     * スクリーンショットアセットの取得
     */
    screenshot: function (type, id) {
      return require(`@/assets/${type}/${id}.png`)
    },
    /**
     * momentで日付をフォーマットして表示
     */
    formatDate: function (date) {
      return moment(date).format('YYYY年M月D日')
    },
    /**
     * 保存時の処理
     */
    onSubmit: async function (ev) {
      this.post.html = this.post.components.map(component => component.html).reduce((p, c) => p + c, '')

      this.post.css = {
        layout: this.post.components.map(component => component.css).reduce((p, c) => !~p.indexOf(c.layout) ? p + c.layout : p, '') + (this.post.header && this.post.header.css ? this.post.header.css.layout : ''),
        theme: this.post.components.map(component => component.css).reduce((p, c) => !~p.indexOf(c.theme) ? p + c.theme : p, '') + (this.post.header && this.post.header.css ? this.post.header.css.theme : '')
      }

      if (this.post.components && this.post.components.length) {
        this.post.extensions = union(...this.post.components.map(component => component.extensions), this.post.header && this.post.header.extensions ? this.post.header.extensions : [])
      }

      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/posts/update', this.post)
      this.isRequesting = false

      if (response.id) {
        this.$notify({
          title: '更新完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '更新失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
    },

    /**
     * コンポーネント追加時にコンポーネント選択ダイアログを表示
     */
    addComponent: function () {
      this.dialogComponentsVisible = true
    },

    /**
     * テンプレート追加時にテンプレート選択ダイアログを表示
     */
    selectTemplate: function (index) {
      this.post.components = cloneDeep(this.appTemplates[index].components)

      this.dialogTemplatesVisible = false
    },

    /**
     * コンポーネント編集後にコンポーネントを入れ替える
     */
    updateComponent: function (index, updated) {
      if (index + 1 === updated.newPosition) return
      this.post.components.splice(updated.newPosition - 1, 0, this.post.components.splice(index, 1)[0])
    },

    /**
     * コンポーネントを削除
     */
    deleteComponent: function (index) {
      this.post.components.splice(index, 1)
      // this.html.splice(index, 1)
      // this.css.splice(index, 1)
      // this.extensions.splice(index, 1)
    },

    /**
     * コンポーネント選択ダイアログでコンポーネントを選択したときの処理
     */
    selectComponent: function (component) {
      this.post.components ? this.post.components.push(component) : this.post.components = [component]
      this.dialogComponentsVisible = false
    },

    /**
     * コンポーネントの入れ替え
     */
    swapComponents: function (index) {
      this.post.components[index] = this.post.components.splice(index + 1, 1, this.post.components[index])[0]
    }
  },
  created: async function () {
    if (process.env.NODE_ENV !== 'production') console.log('On Post created...')

    /**
     * navigationやfooterでpagesが必要になる
     * navigation/sidebar/footerコンポーネントが生成される前に
     * pagesを用意しておかないとrenderingできないため、requestThemesよりも
     * 前にpagesを取得しておく必要がある
     */
    this.isRequesting = true
    try { await this.requestMedia() } catch (error) { return false }
    try { await this.requestPages() } catch (error) { return false }
    try { await this.requestSettings() } catch (error) { return false }
    try { await this.requestThemes() } catch (error) { return false }
    try { await this.requestPosts() } catch (error) { return false }

    this.$store.commit('wordpress/posts/select', this.id)

    if (process.env.NODE_ENV !== 'production') console.log()

    /**
     * 初期状態ではcomponentsは空文字としてWP APIから返ってくる
     * このアプリ側で一つでもコンポーネントが追加されると配列になる
     */
    if (!this.post.components) {
      this.post.components = []
    } else if (typeof this.post.components === 'string') {
      this.post.components = []
    } else {
      if (this.post.components.length !== this.post.components.filter(component => component.id).length) this.post.components = []
    }

    this.isRequesting = false

    this.injectThemeColorsStyle()

    this.isInitialized = true
  },
  destroyed: function () {
    if (process.env.NODE_ENV !== 'production') console.log('Deselect post on Post destroyed...')
    this.$store.commit('wordpress/posts/deselect')
  }
}
</script>

<style scoped lang="scss">
@import '~scss/variables';

.component {
  &-wrapper {
    position: relative;
  }
  &-swap {
    margin: auto;
    position: absolute;
    height: 1.5em;
    left: 0;
    right: 0;
    bottom: -.75em;
    z-index: 1;
    line-height: 1;
    color: #20a0ff;
    font-size: 2em;
    opacity: 0;
    &:hover {
      opacity: 1;
    }
  }
}
</style>

<readme>
# this.post
}
```
{
  "id": number,
  "date": string,
  "date_gmt": string,
  "guid": {
    "rendered": string
  },
  "modified": string,
  "modified_gmt": string,
  "slug": string,
  "status": string,
  "type": string,
  "link": string,
  "title": {
    "rendered": string
  },
  "content": {
    "rendered": string,
    "protected": boolean
  },
  "excerpt": {
    "rendered": string,
    "protected": boolean
  },
  "author": number,
  "featured_media": number,
  "parent": number,
  "menu_order": number,
  "comment_status": string,
  "ping_status": string,
  "template": string,
  "meta": [],
  header: {
    id: number,
    html: string,
    css: string,
    meta: {...},
    contents: {...}
  },
  components: [
    {
      id: number,
      html: string,
      css: string,
      meta: {...},
      contents: {...}
    }
  ],
  css: {
    layout: string,
    theme: string
  },
  extensions: Array<string>
  "_links": any
}
```

</readme>


// WEBPACK FOOTER //
// src/components/routes/Post.vue